<div class="page-title">
  <div class="title" [innerHTML]="'PersonalInfo.Single.Title' | translate | safe:'html'"></div>
  <div class="sub-title">
    <span [innerHTML]="'PersonalInfo.Single.SubTitle' | translate | translateCut:0 | safe:'html'"></span>
    <button (click)="infoDialogService.show(personalInfo)">
      {{ 'PersonalInfo.Single.SubTitle' | translate | translateCut:1 }}
    </button>
  </div>
</div>

<app-personal [(userModel)]="user" (userModelChange)="updateUser()"></app-personal>
